export default __webpack_public_path__ + "static/media/login-bg-7.3f57b891.jpg";